import { connect } from 'react-redux';

import { toggleWebsite, updateWedding } from 'actions/WeddingActions';
import { showModal } from 'actions/ModalActions';

import WeddingDateModal from './WeddingDateModal';

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  publishSite: () =>
    dispatch(toggleWebsite(true)).then(() => {
      if (ownProps.afterPublish) return ownProps.afterPublish();
      return dispatch(showModal('PUBLISH_WEBSITE', {}, { size: 'v2' }));
    }),
  updateWedding: data => dispatch(updateWedding(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeddingDateModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/WeddingDateModal/index.js